module.exports = __webpack_public_path__ + "img/icon_payment_bancontact.2697e95b.svg";